import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  initPickupDeliveryTimes,
  availablePickupDeliveryDates,
  getNexOpenDate
} from "../../../api/helpers/datetimeHelper";
import * as moment from "moment";
import uuid from "uuid/v1";
import { $$ } from "./../../OO_jquery";
import { DefaultPaymentHandler } from "../../../api/payment/DefaultPaymentHandler.js";

import { userIsExist, storeCard } from "../../../api/services/userService";
const dateFotmat = "DD MMMM YYYY";

export default {
  computed: {
    ...mapGetters([
      "user",
      "cartValue",
      "viewConfig",
      "currentStoreDoc",
      "getIsDelivery",
      "deliveryFee",
      "used_coupons",
      "getTotalPrice",
      "isGift",
      "cartItems",
      "getProductOutcomeInfo",
      "applicableLoyalityRule",
      "getMenuEntity",
      "reedemptionLocalUsedPoints",
      "useStampCollection",
      "getSavedPoints"
    ]),
    getPoints() {
      if (this.useStampCollection) return this.getSavedPoints;
      else if (this.applicableLoyalityRule) {
        if (
          this.paymentMethod == 2 &&
          !this.getMenuEntity.IsEarnPointsWhenRedeem
        )
          return 0;
        else
          return Math.floor(
            this.getTotalPrice * this.applicableLoyalityRule.pointPerDollar
          );
      } else return null;
    },
    getRedemPoints() {
      if (this.useStampCollection) return this.reedemptionLocalUsedPoints;
      else this.paymentMethod == 2 ? this.payByPoint.cardValueInPoint : 0;
    },
    payByPoint() {
      var pointsValue =
        this.userInfo.RewardPoints / this.getMenuEntity.PointsToDollarRatio;
      return {
        pointsValue,
        canPay: pointsValue >= this.getTotalPrice,
        cardValueInPoint:
          this.getMenuEntity.PointsToDollarRatio * this.getTotalPrice
      };
    },
    canPayByCard() {},
    orderType() {
      if (this.isDelivery) {
        return 10;
      } else if (this.isChargeToRoom) {
        return 10;
      } else if (this.isEatIn) {
        return 2;
      } else {
        return 3;
      }
    },
    holder() {
      var firstName =
        this.detailModel.FirstName ||
        this.roomDeliveryModel.FirstName ||
        this.eatInModel.FirstName;
      var lastName =
        this.detailModel.LastName ||
        this.roomDeliveryModel.LastName ||
        this.eatInModel.LastName;
      return firstName.trim() + " " + lastName.trim();
    },
    fieldShown() {
      return this.getTotalPrice > 0;
    },
    ChargeToRoomRadioValue() {
      if (!this.viewConfig.ChargeToRoomRadio && this.paymentMethod == 0)
        this.paymentMethod = 1;
      return this.viewConfig.ChargeToRoomRadio;
    }
  },

  methods: {
    ...mapActions([
      "clearCart",
      "signUserUp",
      "signUserIn",
      "applyPriceTriggers"
    ]),
    ...mapMutations([
      "setStoreLoaded",
      "setIsDelivery",
      "REMOVE_CART_ITEM",
      "Add_ProductItem"
    ]),
    saveCredit() {
      this.saveCard = true;
    },
    saveUser(val) {
      this.registerNew = val;
    },
    setRoomNoFromStorage() {
      var roomNo = localStorage.getItem("room");
      if (roomNo) {
        this.roomDeliveryModel.RoomNumber = roomNo;
      }
    },
    deliveryMode() {
      this.setIsDelivery(true);
      this.isDelivery = true;
      this.isPickup = false;
      this.isChargeToRoom = false;
      this.isEatIn = false;
    },
    pickupMode() {
      this.setIsDelivery(false);
      this.isDelivery = false;
      this.isPickup = true;
      this.isChargeToRoom = false;
      this.isEatIn = false;
    },
    chargeToRoomMode() {
      this.setIsDelivery(false);
      this.isDelivery = false;
      this.isPickup = false;
      this.isChargeToRoom = true;
      this.isEatIn = false;
    },
    eatInMode() {
      this.setIsDelivery(false);
      this.isDelivery = false;
      this.isPickup = false;
      this.isChargeToRoom = false;
      this.isEatIn = true;
    },
    setBecomeMemberResult(state) {
      this.registerNew = state;
      if (this.$refs.myDetails)
        this.$refs.myDetails.setRegisterNewUserState(state);
      if (this.$refs.eatIn) this.$refs.eatIn.setRegisterNewUserState(state);
      if (this.$refs.becomeMember) this.$refs.becomeMember.closeModal();
      this.becomeMemberShown = true;
      this.placeOrder();
    },

    placeOrder() {
      let cms = [];
      if (!this.user && !this.store.ChargeToRoom && !this.isEatIn) {
        let p1 = this.$refs.myDetails.validate();
        cms.push(p1);
      }

      if (this.store.ChargeToRoom) {
        if (!this.isEatIn) {
          let p4 = this.$refs.roomDelivery.validate();
          cms.push(p4);
        }
        if (this.paymentMethod == 1) {
          let p2 = this.$refs.payment.validate();
          cms.push(p2);
          let p22 = this.$refs.payment.cardInfoValidate();
          if (p22) cms.push(p22);
        }
      } else {
        if (this.paymentMethod == 1) {
          let p2 = this.$refs.payment.validate();
          cms.push(p2);
          let p22 = this.$refs.payment.cardInfoValidate();
          if (p22) cms.push(p22);
        }
      }
      let p3 = this.$refs.deliveryAddress.validate();
      if (this.isDelivery) {
        cms.push(p3);
      }
      if (this.isEatIn) {
        let p4 = this.$refs.eatIn.validate();
        cms.push(p4);
      }

      var that = this;
      if (
        this.getTotalPrice == 0 &&
        ((!this.store.ChargeToRoom &&
          !this.isEatIn &&
          this.detailModel.FirstName != "") ||
          (this.isEatIn && this.eatInModel.FirstName != ""))
      )
        cms = [];

      Promise.all(cms).then(async values => {
        if (
          values.every(v => v) &&
          this.$refs.deliveryAddress.isDeliveryAreaValid
        ) {
          userIsExist(this.detailModel.Email)
            .then(result => {
              this.userIsExist = result.length > 0;
            })
            .catch(() => {});

          await this.processPayment();
        } else {
          setTimeout(() => {
            $$(that.$el)
              .find("[aria-invalid=true]")
              .focus();
          }, 10);
        }
      });
    },
    clearRoomAndTable() {
      window.localStorage.removeItem("table");
      window.localStorage.removeItem("room");
      window.localStorage.removeItem("coupon");
    },

    async processPayment() {
      if (
        !this.becomeMemberShown &&
        this.viewConfig.LogIn &&
        !this.user &&
        !this.registerNew &&
        !this.userIsExist
      ) {
        this.showBecomeMember = true;
        return;
      } else {
        this.showBecomeMember = false;
      }
      this.proccessing = true;
      this.error = false;
      let payment = new DefaultPaymentHandler();
      //
      let udid = uuid();

      let scheduledTime;
      let dTime = moment(this.selectedTime, "h:mm a");
      scheduledTime = dTime;
      if (this.viewConfig.ShowDeliveryDatePicker && this.isDelivery) {
        let dDate = moment(this.deliveryDate, dateFotmat);
        scheduledTime = dDate.hour(dTime.hour()).minute(dTime.minute());
      }
      if (this.viewConfig.ShowPickupDatePicker && this.isPickup) {
        let dDate = moment(this.pickupDate, dateFotmat);
        scheduledTime = dDate.hour(dTime.hour()).minute(dTime.minute());
      }
      //generate token and save in db
      if (this.saveCard) {
        this.StoreCard();
      }
      let userModel = this.createUserModel();
      userModel.CreateUserForGuest = this.registerNew && !this.userIsExist;
      let cardModel = this.createCardModel();
      if (!this.store.ChargeToRoom) {
        this.roomDeliveryModel.RoomNumber = "";
      }
      if (!this.isEatIn) {
        this.eatInModel.TableNumber = "";
      }
      let orderInfo = {
        orderType: this.orderType,
        notes: this.notes,
        scheduledTime: scheduledTime.toDate().toUTCString(),
        roomNumber: this.roomDeliveryModel.RoomNumber,
        tableNumber: this.eatInModel.TableNumber
      };
      if (this.isDelivery) {
        Object.defineProperty(orderInfo, "DeliveryAddress", {
          value: {
            Address: this.deliveryAddressModel.StreetAddress,
            Postcode: this.deliveryAddressModel.PostalCode,
            Suburb: this.deliveryAddressModel.CityTown,
            State: this.deliveryAddressModel.State,
            Longitude: this.deliveryAddressModel.Latitude,
            Altitude: this.deliveryAddressModel.Altitude
          },
          enumerable: true
        });
      }
      let guestUserId = uuid();
      payment
        .MakePayment(
          udid,
          cardModel,
          userModel,
          this.store,
          orderInfo,
          guestUserId,
          false,
          this.used_coupons,
          {
            RewardPoints: this.getPoints,
            RedeemPoints: this.getRedemPoints
          }
        )
        .then(res => {
          this.proccessing = false;
          if (res.data.Success === true) {
            this.clearCart();
            this.error = "";
            this.clearRoomAndTable();

            if (!userModel.IsGuest)
              this.navigateSuccess(
                udid,
                userModel.ID,
                false,
                userModel.CreateUserForGuest
              );
            else {
              if (userModel.IsGuest && userModel.CreateUserForGuest) {
                storeCard(res.data.customerID, cardModel).then(() => {
                  this.signUserIn({
                    email: userModel.Email,
                    password: guestUserId
                  }).then(() => {
                    this.navigateSuccess(
                      udid,
                      res.data.customerID,
                      false,
                      userModel.CreateUserForGuest
                    );
                  });
                });
              } else {
                this.navigateSuccess(
                  udid,
                  guestUserId,
                  true,
                  userModel.CreateUserForGuest
                );
              }
            }
          } else {
            this.error = res.data.Status.Message;
          }
        })
        .catch(() => {
          this.proccessing = false;
          this.error = "Network Error ...!";
        });
    },
    processSaveOrder() {
      this.proccessing = true;
      let payment = new DefaultPaymentHandler();
      let udid = uuid();
      let scheduledTime = moment(new Date(), "h:mm a");
      let userModel = {
        IsGuest: this.user ? false : true,
        ID: this.user ? this.user.id : "",
        FirstName: this.dbuser ? this.dbuser.FirstName : "",
        LastName: this.dbuser ? this.dbuser.LastName : "",
        DisplayName: "",
        Phone: "",
        Email: this.user ? this.user.email : ""
      };
      userModel.CreateUserForGuest = this.registerNew && !this.userIsExist;
      let orderInfo = {
        orderType: 10,
        notes: "",
        scheduledTime: scheduledTime.toDate().toUTCString(),
        roomNumber: null,
        tableNumber: null
      };
      let guestUserId = uuid();
      payment
        .MakePayment(
          udid,
          {},
          userModel,
          this.store,
          orderInfo,
          guestUserId,
          false,
          null,
          {}
        )
        .then(res => {
          this.proccessing = false;
          if (res.data.Success === true) {
            this.clearCart();
            this.generateQR(udid);
          } else {
            this.error = res.data.Status.Message;
          }
        })
        .catch(() => {
          this.proccessing = false;
          this.error = "Network Error ...!";
        });
    },
    StoreCard() {},
    initModel() {
      //
      if (this.userInfo.DeliveryAddress) {
        this.deliveryAddressModel.StreetAddress = this.userInfo.DeliveryAddress.Address;
        this.deliveryAddressModel.PostalCode = this.userInfo.DeliveryAddress.PostCode;
        this.deliveryAddressModel.CityTown = this.userInfo.DeliveryAddress.City;
        this.deliveryAddressModel.State =
          this.userInfo.DeliveryAddress.State || "";
        this.deliveryAddressModel.Phone =
          this.userInfo.DeliveryAddress.Phone || "";
        this.deliveryAddressModel.DeliveryInstructions =
          this.userInfo.DeliveryAddress.DeliveryInstructions || "";
        this.deliveryAddressModel.Latitude =
          this.userInfo.DeliveryAddress.Latitude || "";
        this.deliveryAddressModel.Altitude =
          this.userInfo.DeliveryAddress.Altitude || "";
      }
    },
    setPickupDeliveryDates() {
      this.disabledDates = availablePickupDeliveryDates(
        this.currentStoreDoc,
        moment()
      );
      var startDate = moment();
      if (this.currentStoreDoc.PreOrderPreparationTime > 0)
        startDate = getNexOpenDate(
          this.currentStoreDoc,
          moment().add(this.currentStoreDoc.PreOrderPreparationTime, "h")
        );
      this.pickupDate = this.deliveryDate = startDate.toDate();
    },
    setPickupDeliveryTimes(date) {
      if (this.deliveryDate != date) {
        this.deliveryDate = date;
      }
      if (this.pickupDate != date) {
        this.pickupDate = date;
      }
      this.dtimes = initPickupDeliveryTimes(date, this.currentStoreDoc);
      this.selectedTime = this.dtimes[0];
    },

    navigateSuccess(udid, userid, isguest, CreateUserForGuest) {
      if (
        (this.viewConfig.LogIn === false || !this.user) &&
        this.viewConfig.ShowTrackingOrderForGuest === false
      ) {
        this.$router.push({
          name: "thankyou",
          params: {
            storeid: this.storeid,
            storename: this.$route.params.storename,
            isGift: false
          }
        });
      } else {
        this.$router.push({
          name: "completeorder",
          params: {
            storeid: this.storeid,
            orderid: udid,
            userid: userid,
            isguest: isguest,
            createUserForGuest: CreateUserForGuest
          }
        });
      }
    },
    computeRules() {
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          if (this.store.OrderTypeConstraintRules[10])
            this.deliveryDisabled = this.store.OrderTypeConstraintRules[10].IsDisabled;
          if (this.store.OrderTypeConstraintRules[3])
            this.pickupDisabled = this.store.OrderTypeConstraintRules[3].IsDisabled;
          if (this.pickupDisabled) {
            this.isChargeToRoom = true;
            this.isPickup = false;
          }
        }
        let table = localStorage.getItem("table");
        if (table) {
          this.eatInMode();
        } else if (this.viewConfig.Delivery) {
          this.deliveryMode();
        } else if (this.viewConfig.PickUp) {
          this.pickupMode();
        } else if (this.viewConfig.DeliverToRoom) {
          this.chargeToRoomMode();
        } else if (this.viewConfig.EatIn) {
          this.eatInMode();
        }
      }
    },
    setUserIsExist(value) {
      this.userIsExist = value;
    },
    createUserModel() {
      var userID = "";
      var firstName = "";
      var lastName = "";
      var displayName = "";
      var phone = "";
      var email = "";
      var isguest = true;
      if (this.user) {
        isguest = false;
        userID = this.user.id;
        firstName = this.userInfo.FirstName;
        lastName = this.userInfo.LastName;
        email = this.user.email;
        phone = this.detailModel.Phone;
      }
      firstName =
        firstName ||
        this.detailModel.FirstName ||
        this.roomDeliveryModel.FirstName ||
        this.eatInModel.FirstName;
      lastName =
        lastName ||
        this.detailModel.LastName ||
        this.roomDeliveryModel.LastName ||
        this.eatInModel.LastName;
      email =
        email ||
        this.detailModel.Email ||
        this.roomDeliveryModel.Email ||
        this.eatInModel.Email;
      phone = this.detailModel.Phone;
      displayName = firstName + " " + lastName;
      return {
        IsGuest: isguest,
        ID: userID,
        FirstName: firstName.trim(),
        LastName: lastName.trim(),
        DisplayName: displayName.trim(),
        Phone: phone.trim(),
        Email: email.trim()
      };
    },
    createCardModel() {
      let exDate = this.paymentModel.ExpireDate.split("/");
      let isToken = false;
      if (this.paymentModel.SelectedCard) {
        isToken = true;
      }
      let useCard = !isToken && this.paymentMethod == 1;
      return {
        exclude: !useCard,
        isToken: isToken,
        token: isToken ? this.paymentModel.SelectedCard.CardIdentifier : "",
        cvc: this.paymentModel.CVV,
        expMonth: exDate[0],
        expYear: useCard ? exDate[1] : "",
        number: this.paymentModel.CardNumber,
        holder: this.paymentModel.CardHolder.trim()
      };
    },
    clearAllOrders() {
      this.cartItems.forEach(cartitem => {
        this.REMOVE_CART_ITEM({ item: cartitem });
        this.applyPriceTriggers();
      });
    }
  }
};
